import { createSlice } from "@reduxjs/toolkit";
import { fetchRecordLevelWarehouseWise } from "./thunk";

interface DistrictState {
  recordLevelwarehousewiseList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  recordLevelwarehousewiseList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "Inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecordLevelWarehouseWise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecordLevelWarehouseWise.fulfilled, (state, action) => {
        state.loading = false;
        state.recordLevelwarehousewiseList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchRecordLevelWarehouseWise.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetchRecordLevelWarehouseWise";
      });
  },
});

export default inventorySlice.reducer;
